// jgd-rcc-autoload — Hybrid-Infinite-Scroll für das RCC-Produktgrid.
//
// Klickt RCCs "Mehr laden"-Button automatisch, sobald er in Scroll-Nähe kommt
// (rootMargin lädt nach, bevor der Nutzer den Button sieht). Nach
// MAX_AUTO_LOADS automatischen Klicks verhält sich der Button wieder manuell —
// bewusst als Cap, damit der Footer (Impressum/Datenschutz) per Scroll
// erreichbar bleibt. Ein echter Nutzer-Klick auf den Button (isTrusted) setzt
// das Kontingent zurück: danach lädt das Scrollen wieder bis zu
// MAX_AUTO_LOADS Seiten automatisch nach, usw.
//
// Voraussetzung: Das RCC-Grid muss in der App-Konfiguration im
// "Load more"-Modus laufen — im Seitenzahlen-Modus existiert der Button nicht
// und dieses Script tut nichts. Der Selektor ist RCC-Markup und kann bei
// App-Updates driften — nach Updates prüfen.

(() => {
  const SELECTOR = '.rcc-search__loadmore__button';
  const MAX_AUTO_LOADS = 5;
  const COOLDOWN_MS = 1000;
  const ROOT_MARGIN = '600px 0px';

  let autoClicks = 0;
  let coolingDown = false;
  /** @type {Set<Element>} */
  const buttons = new Set();

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) autoClick(entry.target);
      }
    },
    { rootMargin: ROOT_MARGIN }
  );

  /** @param {Element} button */
  function nearViewport(button) {
    const rect = button.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight + 600 && rect.bottom > -600;
  }

  /** @param {Element} button */
  function autoClick(button) {
    if (autoClicks >= MAX_AUTO_LOADS || coolingDown || !button.isConnected) return;

    autoClicks += 1;
    coolingDown = true;
    button.click();
    scheduleResume();
  }

  // IntersectionObserver feuert nur bei Zustandswechseln — bleibt der Button
  // (oder sein neu gerenderter Nachfolger) dauerhaft im Sichtbereich, stößt
  // erst das Cooldown-Ende den nächsten Klick an.
  function scheduleResume() {
    setTimeout(() => {
      coolingDown = false;
      for (const candidate of buttons) {
        if (!candidate.isConnected) {
          buttons.delete(candidate);
          continue;
        }
        if (nearViewport(candidate)) {
          autoClick(candidate);
          break;
        }
      }
    }, COOLDOWN_MS);
  }

  /** @param {Element} button */
  function observe(button) {
    if (buttons.has(button)) return;
    buttons.add(button);
    io.observe(button);
  }

  /** @param {ParentNode} root */
  function scan(root) {
    for (const button of root.querySelectorAll(SELECTOR)) observe(button);
  }

  const mo = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(SELECTOR)) observe(node);
        scan(node);
      }
    }
  });

  // Echter Nutzer-Klick auf den Button (Script-Klicks haben isTrusted=false):
  // Kontingent zurücksetzen — der Nutzer hat aktiv "mehr" verlangt, also darf
  // das Scrollen wieder MAX_AUTO_LOADS Seiten nachladen.
  document.addEventListener(
    'click',
    (event) => {
      if (!event.isTrusted || !(event.target instanceof Element)) return;
      if (!event.target.closest(SELECTOR)) return;
      autoClicks = 0;
      // Der manuelle Klick lädt selbst eine Seite — nach dem Cooldown die
      // Automatik wieder anlaufen lassen, falls der Button sichtbar blieb.
      coolingDown = true;
      scheduleResume();
    },
    { capture: true, passive: true }
  );

  mo.observe(document.body, { childList: true, subtree: true });
  scan(document);
})();
